// src/pages/ServicesPage.jsx
import { Link } from 'react-router-dom';
import { FaWifi, FaBuilding, FaHome } from 'react-icons/fa';
import Layout from '../components/Layout';

export default function ServicesPage() {
  return (
    <Layout>
      <div className="page-container">
        <div className="page-content">
          <h1>Our Services</h1>
          <p className="page-subtitle">
            Comprehensive internet solutions for every need
          </p>

          <div className="services-grid-page">
            <div className="service-card-page">
              <FaHome className="service-icon-page" />
              <h2>Residential Internet</h2>
              <p>
                Unlimited fixed wireless internet for your home. 
                Starting at KSh 1,500/month with no data caps.
              </p>
              <ul>
                <li>10 Mbps - 20 Mbps speeds</li>
                <li>Unlimited data, no throttling</li>
                <li>Free equipment on approval</li>
                <li>24/7 support</li>
              </ul>
              <Link to="/#residential" className="service-link">Learn More →</Link>
            </div>

            <div className="service-card-page">
              <FaBuilding className="service-icon-page" />
              <h2>Business Internet</h2>
              <p>
                Dedicated bandwidth with SLA-backed uptime for 
                businesses of all sizes.
              </p>
              <ul>
                <li>30 Mbps - Custom speeds</li>
                <li>Static IP addresses</li>
                <li>4-hour response guarantee</li>
                <li>Named account manager</li>
              </ul>
              <Link to="/#business" className="service-link">Learn More →</Link>
            </div>

            <div className="service-card-page">
              <FaWifi className="service-icon-page" />
              <h2>On-Demand WiFi</h2>
              <p>
                No subscription needed. Buy data bundles and connect 
                instantly at participating locations.
              </p>
              <ul>
                <li>500 MB - 5 GB bundles</li>
                <li>No expiry on bundles</li>
                <li>Available in Kisumu estates</li>
                <li>Guest WiFi for businesses</li>
              </ul>
              <Link to="/#wifi" className="service-link">Learn More →</Link>
            </div>
          </div>

          <div className="service-cta">
            <h3>Ready to get connected?</h3>
            <Link to="/#contact" className="cta-button-page">
              Contact Us Today
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}